<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  /** Diameter of each dot in pixels. */
  size?: number
  /** Tailwind background color class for the dots. */
  colorClass?: string
}>(), {
  size: 6,
  colorClass: 'bg-neutral-400',
})

const dotStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
}))
</script>

<template>
  <span class="inline-flex items-center gap-1" role="status" aria-label="Thinking">
    <span
      class="inline-block rounded-full animate-pulse-dot"
      :class="colorClass"
      :style="{ ...dotStyle, animationDelay: '0s' }"
    />
    <span
      class="inline-block rounded-full animate-pulse-dot"
      :class="colorClass"
      :style="{ ...dotStyle, animationDelay: '0.2s' }"
    />
    <span
      class="inline-block rounded-full animate-pulse-dot"
      :class="colorClass"
      :style="{ ...dotStyle, animationDelay: '0.4s' }"
    />
  </span>
</template>
